///////////////////////////////////////////////////////////////////////////////////////
//                          Copyright (c) 2020 - 2020
//                           Coyote Logistics L.L.C.
//                         All Rights Reserved Worldwide
//
//WARNING:  This program (or document) is unpublished, proprietary
//property of Coyote Logistics L.L.C. and is to be maintained in strict confidence.
//Unauthorized reproduction, distribution or disclosure of this program
//(or document), or any program (or document) derived from it is
//prohibited by State and Federal law, and by local law outside of the U.S.
///////////////////////////////////////////////////////////////////////////////////////

import { createSlice } from "@reduxjs/toolkit";
import defaultSpotFilters from "../helpers/defaultSpotFilters";
import {
  fetchSpotLegsWithFilters,
  fetchSpotLegsWithSearchTerm,
  fetchSpotLegsV2
} from "./spotLegsSlice";
import _isEqual from "lodash/isEqual";
import _omit from "lodash/omit";

import { setFilterQueryStringParameters } from "../helpers/urlHelpers";

export const initialState = defaultSpotFilters;

const spotFiltersSlice = createSlice({
  name: "spotFiltersSlice",
  initialState,
  reducers: {
    setSpotFilters: (state, { payload }) => {
      return payload;
    },
  },
});

export const { setSpotFilters } = spotFiltersSlice.actions;

export const updateSpotFilters = (payload) => (dispatch, getState) => {
  const state = getState();
  let pageWasChanged =
    payload.filters.currentPage >= 0 &&
    payload.filters.currentPage !== state.spotFilters.currentPage;
  let updatedFilters;
  let fetchSpotLegsActionCreator = fetchSpotLegsWithFilters;

  if (
    pageWasChanged ||
    (!_isEqual(
      _omit(payload.filters, ["status"]),
      _omit(defaultSpotFilters, ["status"])
    ) &&
      (payload.filters.sortType !== undefined ||
        payload.filters.sortDirection !== undefined))
  ) {
    updatedFilters = {
      ...state.spotFilters,
      currentPage: payload.filters.currentPage ?? state.spotFilters.currentPage,
      sortType:
        payload.filters.sortType === undefined
          ? state.spotFilters.sortType
          : payload.filters.sortType,
      sortDirection:
        payload.filters.sortDirection === undefined
          ? state.spotFilters.sortDirection
          : payload.filters.sortDirection,
    };

    if (state.spotFilters.searchTerm !== null) {
      fetchSpotLegsActionCreator = fetchSpotLegsWithSearchTerm;
    }
  } else if (payload.filters.searchTerm) {
    updatedFilters = {
      ...defaultSpotFilters,
      currentPage: 0,
      searchTerm: payload.filters.searchTerm,
    };
    fetchSpotLegsActionCreator = fetchSpotLegsWithSearchTerm;
  } else {
    updatedFilters = {
      ...state.spotFilters,
      ...payload.filters,
      currentPage: 0,
    };
  }

  setFilterQueryStringParameters(payload.history, updatedFilters);
  dispatch(setSpotFilters(updatedFilters));
  dispatch(fetchSpotLegsActionCreator(updatedFilters.currentPage));
};

export const updateSpotFiltersV2 = (payload) => (dispatch, getState) => {
  const state = getState();

  let updatedFilters = {
    ...state.spotFilters,
    ...payload.filters,
    currentPage: payload.filters.currentPage ?? state.spotFilters.currentPage,
    sortType:
      payload.filters.sortType === undefined
        ? state.spotFilters.sortType
        : payload.filters.sortType,
    sortDirection:
      payload.filters.sortDirection === undefined
        ? state.spotFilters.sortDirection
        : payload.filters.sortDirection,
    searchTerm:
      payload.filters.searchTerm === undefined
        ? state.spotFilters.searchTerm
        : payload.filters.searchTerm,
  };

  let filtersHaveNotChanged = payload.filters.sortType !== undefined || payload.filters.sortDirection !== undefined || payload.filters.currentPage !== undefined;

  // Reset paging if we change any of the filters...
  if (!filtersHaveNotChanged) {
    updatedFilters.currentPage = 0;
  }

  setFilterQueryStringParameters(payload.history, updatedFilters);
  dispatch(setSpotFilters(updatedFilters));
  dispatch(fetchSpotLegsV2(updatedFilters));
};

export const spotFiltersReducer = spotFiltersSlice.reducer;
